import { TRANSITIONS, TransitionType } from 'enums'

export const isWipeTransition = (type: TransitionType) => {
  switch (type) {
    case TRANSITIONS.WIPE_UP:
    case TRANSITIONS.WIPE_DOWN:
    case TRANSITIONS.WIPE_LEFT:
    case TRANSITIONS.WIPE_RIGHT:
      return true
    default:
      return false
  }
}
